export const TOUR_TRIPS_START = "TOUR_TRIPS_START";
export const TOUR_TRIPS_SUCCESS = "TOUR_TRIPS_SUCCESS";
export const TOUR_TRIPS_ERROR = "TOUR_TRIPS_ERROR";